import { useCallback, useEffect, useState } from 'react'
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable'
import {
  Card,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  HStack,
  Divider,
  CardHeader,
  Heading,
  CardBody,
  Text,
  Box,
  Spacer,
} from '@chakra-ui/react'
import { FiColumns } from 'react-icons/fi'
import ColumnMenuItem from './ColumnMenuItem'
import { camelToWords } from '@/utils/stringHelper'
import AppliedColumnCard from './AppliedColumnCard'
import { useTranslation } from 'react-i18next'
import { AddButton } from '@/components/Elements/Button'

const ColumnEditButton = ({ table }) => {
  //Table State
  const columns = table.getAllLeafColumns()
  const { t } = useTranslation()

  const visibleColumns = columns.filter((col) => col.getIsVisible())
  const invisibleColumns = columns.filter((col) => !col.getIsVisible())
  const columnOrder = table.getState().columnOrder

  //Local State
  const [modalShow, setModalShow] = useState(false)
  const [availableColumns, setAvailableColumns] = useState(invisibleColumns)
  const [appliedColumns, setAppliedColumns] = useState(visibleColumns)
  visibleColumns

  const handleAddColumn = (column) => {
    setAppliedColumns((prev) => [...prev, column])
    setAvailableColumns((prev) => [...prev].filter((prevColumn) => prevColumn.id !== column.id))
  }
  const handleRemoveColumn = (column) => {
    setAppliedColumns((prev) => [...prev].filter((prevColumn) => prevColumn.id !== column.id))
    setAvailableColumns((prev) => [...prev, column])
  }

  const closeModal = () => {
    setModalShow(false)

    //Reset Unsaved changes
    // setAppliedColumns(visibleColumns);
    // setAvailableColumns(invisibleColumns);
  }
  const handleSave = () => {
    const allColumns = new Set([...appliedColumns, ...availableColumns])

    // Create the resulting object
    const columnVisibility = {}

    // Populate the object with keys and boolean values
    allColumns.forEach(({ id }) => {
      columnVisibility[id] = appliedColumns.some((column) => column.id === id)
    })

    table.setState((state) => {
      return {
        ...state,
        columnOrder: appliedColumns.map((column) => column.id),
        columnVisibility: columnVisibility,
      }
    })

    closeModal()
  }

  return (
    <>
      <Modal isOpen={modalShow} onClose={closeModal} size="xl">
        <ModalOverlay />
        <ModalContent mt="3" maxW="60%">
          <ModalHeader>{t('TABLE_EDIT_COLUMN')}</ModalHeader>
          <ModalCloseButton />
          <ModalBody backgroundColor={'#f7f9fb'}>
            <Flex w="100%" justifyContent={'center'} gap="5" h="500px">
              <Card w="50%" overflowY={'scroll'}>
                <CardHeader>
                  <Heading size="md">{t('TABLE_AVAILABLE_COLUMN')}</Heading>
                </CardHeader>
                <CardBody>
                  {availableColumns.map((column) => (
                    <Flex key={column.id} my="2" ml="5">
                      <Text>{camelToWords(column.id)}</Text>
                      <Spacer />
                      <AddButton onClick={() => handleAddColumn(column)} />
                    </Flex>
                  ))}
                </CardBody>
              </Card>
              <Divider orientation="vertical" />

              <AppliedColumnCard
                columns={appliedColumns}
                setColumns={setAppliedColumns}
                handleRemoveColumn={handleRemoveColumn}
              />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Flex gap="2">
              <Button colorScheme="teal" onClick={handleSave}>
                Save
              </Button>
              <Button colorScheme="gray" onClick={() => setModalShow(false)}>
                Close
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Button
        p="2"
        borderRadius={10}
        size="sm"
        rightIcon={<FiColumns />}
        onClick={() => setModalShow(true)}
        maxW="100px"
        variant={'solid'}
      >
        {t('TABLE_COLUMN')}
      </Button>
    </>
  )
}

export default ColumnEditButton
